/**
 * `/code-review/instructions` — *Custom Instructions* section.
 */
import { SettingsForm } from '../../components/SettingsForm.js';

export default function CodeReviewInstructions() {
  return (
    <main className="feluda-settings">
      <SettingsForm
        section="instructions"
        title="Custom Instructions"
        subtitle="Tune the prompts Feluda uses when reviewing."
      />
    </main>
  );
}
